import { IAlarmsFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';
import { TEmptyObject } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useQueryAlarmHistory } from '../useQueryAlarmHistory';
import { useQueryAlarmHistoryFlexidas } from '../useQueryAlarmHistoryFlexidas';

import { useQueryHistoryAlarmsListOran } from './useQueryHistoryAlarmsListOran';

interface IUseQueryAlarmsReturn {
	isLoadingTable: boolean;
	historyAlarmList: IAlarmsFlexidas[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

interface AlarmData<T = any> {
	isLoading: boolean;
	data: T[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

const getAlarmsList = ({
	flexidas,
	limenet,
	oran,
	vendor,
}: {
	flexidas: AlarmData;
	limenet: AlarmData;
	oran: AlarmData;
	vendor: string;
}): TEmptyObject | AlarmData => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return flexidas;
		case EVendorsValues.limenet:
			return limenet;
		case EVendorsValues.oran:
			return oran;
		default:
			return {};
	}
};

export const useQueryHistoryAlarmsList = (params: IAlarmByVendor): IUseQueryAlarmsReturn => {
	const flexidas = useQueryAlarmHistoryFlexidas(params);
	const limenet = useQueryAlarmHistory(params);
	const oran = useQueryHistoryAlarmsListOran(params);

	const {
		data = [],
		isLoading = false,
		countOfRecords = 0,
		invalidateQuery,
	} = getAlarmsList({
		flexidas,
		limenet,
		oran,
		vendor: params.vendor,
	}) || {};

	return {
		isLoadingTable: isLoading,
		historyAlarmList: data,
		countOfRecords: countOfRecords,
		invalidateQuery,
	};
};
